export enum BillerDetailsSource {
  BILLERS = 'billers',
  SOURCE_CHANGE = 'sourceChange',
  AVAILABLE_BILLERS = 'availableBillers',
  EMPTY_CART = 'emptyCart'
}
